import { render, staticRenderFns } from "./ProductWithCategory.vue?vue&type=template&id=596102ee"
import script from "./ProductWithCategory.vue?vue&type=script&lang=js"
export * from "./ProductWithCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports